import YYCheckbox from './checkbox.vue'
import YYCheckboxGroup from './checkbox-group.vue'

YYCheckbox.YYCheckboxGroup = YYCheckboxGroup
export default YYCheckbox